import React, { useState } from 'react';
import styles from './DashboardPage.module.css';
import DappNav from '../components/dappNav/dappNav';
import Tasks from './Tasks/Tasks';
import Referral from './Referral/Referral';
import Recent from './Recent/Recent';
import Stats from './Stats/Stats';
import Footer from '../../../components/Footer/Footer';

const EarnPage = () => {
  const [activeTab, setActiveTab] = useState('tasks');

  return (
    <div className={styles.earnPage}>
      <DappNav />
      <div className={styles.container}>
        <Stats />
        <div className={styles.tabsSection}>
          <div className={styles.tabs}>
            <button 
              className={`${styles.tab} ${activeTab === 'tasks' ? styles.active : ''}`}
              onClick={() => setActiveTab('tasks')}
            >
              Tasks
            </button>
            <button 
              className={`${styles.tab} ${activeTab === 'referral' ? styles.active : ''}`}
              onClick={() => setActiveTab('referral')}
            >
              Referral
            </button>
          </div>
          <div className={styles.content}>
            {activeTab === 'tasks' ? <Tasks /> : <Referral />}
          </div>
        </div>
        <Recent />
      </div>
      <Footer />
    </div>
  );
};

export default EarnPage;